import SortBy from '../../common/components/FiltersPanel/SortBy';
import License from '../../common/components/FiltersPanel/License';
import Orientation from '../../common/components/FiltersPanel/Orientation';
import Resolution from '../../common/components/FiltersPanel/Resolution';
import Duration from '../../common/components/FiltersPanel/Duration';
import People from '../../common/components/FiltersPanel/People';
import Age from '../../common/components/FiltersPanel/Age';
import Ethnicity from '../../common/components/FiltersPanel/Ethnicity';
import Color from '../../common/components/FiltersPanel/Color';
import More from '../../common/components/FiltersPanel/More';

export const FILTERS_MAP = [
  {
    name: 'sortBy',
    component: SortBy,
  },
  {
    name: 'license',
    component: License,
  },
  {
    name: 'orientations',
    component: Orientation,
  },
  {
    name: 'formatAvailable',
    component: Resolution,
  },
  {
    name: 'duration',
    component: Duration,
  },
  {
    name: 'numberOfPeople',
    component: People,
  },
  {
    name: 'ageOfPeople',
    component: Age,
  },
  {
    name: 'ethnicity',
    component: Ethnicity,
  },
  {
    name: 'color',
    component: Color,
  },
  {
    name: 'more',
    component: More,
  },
];
